import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UserInfo } from '@ca/core/models';
import { UserService } from '@ca/core/services';

export interface AvatarModel {
    avatarUrl?: string;
    shortName?: string;
    avatarUserId?: string;
}

@Component({
    selector: 'ca-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {
    private _avatarModel: AvatarModel;

    @Input() set avatarModel(avatarModel: AvatarModel) {
        this._avatarModel = avatarModel;
    }

    get avatarModel(): AvatarModel {
        return this._avatarModel;
    }

    get userInfo(): UserInfo | undefined {
        return this.userService.myInfo;
    }

    get isMine(): boolean {
        return this.userService.isOwner(this.avatarModel?.avatarUserId || '');
    }

    get avatarPicture(): string | undefined {
        let avatarUrl: string | undefined = undefined;
        if (this.isMine && this.userInfo != null) {
            avatarUrl = this.userInfo.picture;
        } else if (this.avatarModel?.avatarUrl != null) {
            avatarUrl = this.avatarModel?.avatarUrl;
        }
        return avatarUrl;
    }

    constructor(private userService: UserService) {}
}
